module.exports = __webpack_public_path__ + "img/tear_tha_plasticbag2.2424a716.png";